import PermContactCalendarOutlinedIcon from '@mui/icons-material/PermContactCalendarOutlined';
import { Link } from '@mui/material';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import * as React from 'react';

import Typography from './HomeTypography';

export const Contact = () => {
  return (
    <Container
      component="section"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        my: 9,
      }}
    >
      <PermContactCalendarOutlinedIcon fontSize="large" sx={{ mb: 3 }} />
      <Button
        sx={{
          border: '4px solid currentColor',
          borderRadius: 0,
          height: 'auto',
          py: 2,
          px: 5,
        }}
        href="mailto:laflute.troyes@gmail.com"
      >
        <Typography variant="h4" component="span">
          {"Des questions ? Besoin d'aide ?"}
        </Typography>
      </Button>
      <Typography variant="subtitle1" sx={{ my: 3 }}>
        Contacter la flute : laflute.troyes@gmail.com
      </Typography>
      <Link variant="subtitle1" href="/legal">
        Mentions Légales
      </Link>
    </Container>
  );
};
